import './Emphasis.css';
export var emphasisCSS = '_1r35rtu0-3-12-1';